import { useEffect } from 'react';
import { usePosts, usePaginatePosts } from 'hooks/posts';

import AsyncTable from 'components/Tables/AsyncTable';
import { useFilters } from 'hooks/filters';
import { Text } from '@chakra-ui/react';
import { postStatus } from 'variables/postStatus';
import dateFormat from 'functions/dateFormat';

const columns = [
	{
		Header: 'Título',
		accessor: 'title'
	},
	{
		Header: 'Categoria',
		accessor: 'topic.category.title'
	},
	{
		Header: 'Tópico',
		accessor: 'topic.title'
	},
	{
		Header: 'Template',
		accessor: 'template.title'
	},
	{
		Header: 'Status',
		accessor: 'status',
		Cell: ({ value }) => <Text>{postStatus[value]}</Text>
	},
	{
		Header: 'Cadastrado em',
		accessor: 'created_at',
		Cell: ({ value }) => (
			<Text>{dateFormat(value, 'dd/MM/yyyy HH:mm')}</Text>
		)
	}
];

const PostsTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		usePosts();
	const [paginatePosts, { loading }] = usePaginatePosts({});

	const deleteCategory = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex, search }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginatePosts({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				search: search || '',
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginatePosts({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="posts"
			removeAction={deleteCategory}
			linkRow
		/>
	);
};

export default PostsTable;
